module.exports = __webpack_public_path__ + "img/avatar.48eb1ed0.png";